import {createContext, useContext} from 'react'
import {WidgetProps} from '../Widget/interfaces'

export const WidgetPropsContext = createContext<WidgetProps>(null)
export const useWidgetProps = () => useContext(WidgetPropsContext)
